module.exports = __webpack_public_path__ + "static/media/single-left-blue.31fdaeef.svg";